function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "jcb-light");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Cards",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Payment-Methods",
  transform: "translate(-848.000000, -316.000000)",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "jcb-light",
  transform: "translate(848.000000, 316.000000)"
}, React.createElement("rect", {
  id: "card_bg",
  fill: "#DFE3E8",
  x: 0,
  y: 0,
  width: 24,
  height: 16,
  rx: 2
}), React.createElement("g", {
  id: "jcb-logo",
  transform: "translate(4.000000, 2.000000)"
}, React.createElement("rect", {
  id: "Rectangle",
  fill: "#FFFFFF",
  x: 0.02,
  y: 3.51,
  width: 4.92,
  height: 5.12
}), React.createElement("rect", {
  id: "Rectangle",
  fill: "#FFFFFF",
  x: 5.54,
  y: 3.21,
  width: 4.93,
  height: 5.87
}), React.createElement("rect", {
  id: "Rectangle",
  fill: "#FFFFFF",
  x: 11.06,
  y: 3.02,
  width: 4.93,
  height: 6.17
}), React.createElement("path", {
  d: "M12.05,7.29 L13.2,7.29 L13.35,7.29 C13.5903851,7.24113649 13.759822,7.02510442 13.75,6.78 C13.7528571,6.53505674 13.587481,6.32006785 13.35,6.26 L12.05,6.26 L12.05,7.29 Z",
  id: "Path",
  fill: "#40A648"
}), React.createElement("path", {
  d: "M13.07,0 C11.9654305,0 11.07,0.8954305 11.07,2 L11.07,4.08 L14.07,4.08 C14.71,4.08 15.18,4.44 15.18,5.01 C15.1693981,5.50812159 14.7681216,5.90939809 14.27,5.92 L14.27,6 C14.92,6 15.41,6.4 15.41,7 C15.41,7.6 14.86,8 14.14,8 L11.04,8 L11.04,12 L14,12 C15.1045695,12 16,11.1045695 16,10 L16,0 L13.07,0 Z",
  id: "Path",
  fill: "#40A648"
}), React.createElement("path", {
  d: "M13.61,5.15 C13.611945,4.91215949 13.4359034,4.71035568 13.2,4.68 L12.05,4.68 L12.05,5.68 L13.2,5.68 C13.437454,5.64501107 13.612564,5.44000431 13.61,5.2 L13.61,5.15 Z",
  id: "Path",
  fill: "#40A648"
}), React.createElement("path", {
  d: "M2,0 C0.8954305,0 0,0.8954305 0,2 L0,6.93 C0.530642138,7.21144767 1.11951354,7.36551286 1.72,7.38 C1.99712178,7.39944707 2.26984431,7.30273959 2.47280767,7.1130542 C2.67577103,6.92336882 2.79068151,6.65780246 2.79,6.38 L2.79,4.07 L4.52,4.07 L4.52,6.38 C4.52,7.29 4,8 2.06,8 C1.38577145,7.99637788 0.714374656,7.91245328 0.06,7.75 L0.06,12 L2.94,12 C3.47043298,12 3.97914081,11.7892863 4.35421356,11.4142136 C4.72928632,11.0391408 4.94,10.530433 4.94,10 L4.94,0 L2,0 Z",
  id: "Path",
  fill: "#0D67B0"
}), React.createElement("path", {
  d: "M7.54,0 C6.4354305,0 5.54,0.8954305 5.54,2 L5.54,4.62 C6.36732364,4.07190615 7.36885331,3.85092807 8.35,4 C8.87948596,4.0326224 9.40494914,4.11294798 9.92,4.24 L9.92,5.09 C9.45051534,4.83659927 8.93224998,4.68657509 8.4,4.65 C7.32,4.57 6.68,5.1 6.68,6.02 C6.68,6.94 7.32,7.48 8.4,7.39 C8.93141052,7.34874285 9.4487239,7.19899424 9.92,6.95 L9.92,7.8 C9.40536227,7.92911378 8.87970765,8.00946862 8.35,8.04 C7.3663487,8.18322832 6.36460742,7.95507372 5.54,7.4 L5.54,12 L8.48,12 C9.5845695,12 10.48,11.1045695 10.48,10 L10.48,0 L7.54,0 Z",
  id: "Path",
  fill: "#BE2034"
})))));

var SvgJcb = function SvgJcb(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "24px",
    height: "16px",
    viewBox: "0 0 24 16",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgJcb, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/jcb.ca14bdc3.svg";
export { ForwardRef as ReactComponent };